/**
 * Global configuration object for the application.
 * @type {Object}
 */
/**
 * Configuration object for the application.
 * @type {Object}
 */
export const appConfig = {
  /**
   * Configuration for API versions.
   * @type {Object}
   */
  api: {
    /**
     * Configuration for API version 2.
     * @type {Object}
     */
    v2: {
      /**
       * Endpoints for API version 2.
       * @type {Object}
       */
      endpoints: {
        /**
         * Endpoints related to statistics for API version 2.
         * @type {Object}
         */
        stats: {
          /**
           * Endpoint for call entries per month statistics.
           * @type {string}
           */
          entriesPerMonth: "/stats/call-entries",

          /**
           * Endpoint for call entries per state/province statistics.
           * @type {string}
           */
          entriesByStateProvince: "/stats/call-entries/states-provinces",

          /**
           * Endpoint for call entries per state/province statistics.
           * @type {string}
           */
          entriesPerCallTaker: "/stats/call-takers/entries",

          /**
           * Endpoint for shifts per call taker statistics.
           * @type {string}
           */
          shiftsPerCallTaker: "/stats/call-takers/shifts",
          /**
           * Endpoint for entries per call taker statistics.
           * @type {string}
           */

          /**
           * Endpoint for call referrals per month statistics.
           * @type {string}
           */
          referralsPerMonth: "/stats/call-entries/referrals",

          /**
           * Endpoint for call referrals frequency statistics.
           * @type {string}
           */
          referralsFrequency: "/stats/call-entries/referrals-frequency",

          /**
           * Endpoint for call entries per Copline Referral.
           * @type {string}
           */
          entriesPerCoplineReferral: "/stats/call-entries/copline-referrals",
        },
        /**
         * Endpoints related to briefings for API version 2.
         * @type {string}
         */
        briefings: "/briefings",

        /**
         * Endpoints related to providers for API version 2.
         * @type {string}
         */
        providers: "/providers",

        /**
         * Endpoints related to shift assignments for API version 2.
         * @type {string}
         */
        shiftAssignments: "/shift-assignments",

        /**
         * Endpoints related to text-blast sending for API version 2.
         * @type {string}
         */
        textBlasts: "/text-blasts",

        honorWall: {
          /**
           * Endpoints related to honor-wall recognitions for API version 2.
           * @type {string}
           */
          recognitions: "/honor-wall/recognitions",
        },

        /**
         * Endpoints related to voicemails for API version 2.
         * @type {string}
         */
        voicemails: "/hotline/twilio/voicemail",

        /**
         * Endpoints related to call takers for API version 2.
         * @type {string}
         */
        callTakers: "/call-takers",

        /**
         * Endpoints related to call reports for API version 2.
         * @type {string}
         */
        callReports: "/call-reports",

        /**
         * Endpoints related to lessons for API version 2.
         * @type {string}
         */
        lessons: "/lessons",

        /**
         * Endpoints related to lesson responses for API version 2.
         * @type {string}
         */
        lessonResponses: "/lesson-responses",
      },
      /**
       * Base URL for API version 2.
       * @type {string}
       */
      baseUrl: process.env.REACT_APP_API_V2_URL,
    },
  },

  /**
   * Configuration for Sentry (error tracking and performance monitoring).
   * @type {Object}
   */
  sentry: {
    /**
     * Sentry Data Source Name (DSN).
     * @type {string}
     */
    dsn: process.env.REACT_APP_SENTRY_DSN,
    /**
     * Environment name (e.g., production, development).
     * @type {string}
     */
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    /**
     * Sample rate for performance traces.
     * @type {number}
     */
    tracesSampleRate: 1.0,
    /**
     * Sample rate for session replays.
     * @type {number}
     */
    replaysSessionSampleRate: 0.1,
    /**
     * Sample rate for error replays.
     * @type {number}
     */
    replaysOnErrorSampleRate: 1.0,
  },

};
